import React from "react";
import Styles from "./ChangeServices.module.scss";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../../shared/styles/useTheme";
import classNames from "classnames";
import { Button } from "@App/components/@remote";
import { Link } from "react-router-dom";
import { Icon } from "@/App/components/@remote";
import { csFormPageStormUrl, csFormPageGasUrl, csFormPageHeatpumpUrl, baseRoute } from "@/routes/changeservice";

type Props = {
  className?: string;
  changeServices: Remote.ChangeService[];
};

function isMissingData(ch: Remote.ChangeService) {
  return ch.hasMissingData;
}

export const ChangeServices = ({ className, changeServices }: Props) => {
  const { t } = useTranslation();
  const { link, warningBackground } = useTheme();
  const hasChangeServices = Object.values(changeServices).flat(Infinity).length > 0;
  const missingDataChangeServices = Object.values(changeServices).flat(Infinity).filter(isMissingData);
  const activeChangeServices = Object.values(changeServices)
    .flat(Infinity)
    ?.filter((ch) => ch?.active);

  const activeChangeServicesCount = activeChangeServices.filter((ch) => {
    return !missingDataChangeServices.find((missingCh) => missingCh.id === ch.id);
  }).length;

  const subTitle = hasChangeServices
    ? t("dashboard.changeServices.description.changeServices")
    : t("dashboard.changeServices.description.noChangeServices");

  const BoxButton = ({ text, link, classname }: { text: string; link: string; classname?: string }) => {
    return (
      <Button className={classNames(Styles.button, classname)}>
        <Link to={link} className={Styles.btnContent}>
          {text} <Icon className={Styles.arrow} name={"arrowRight"} />
        </Link>
      </Button>
    );
  };

  const boxContent = hasChangeServices ? (
    <>
      <BoxButton classname={Styles.boxButton} link={baseRoute} text={t("dashboard.seeChangeServices")} />
      <div>
        <div className={Styles.upperShadow}></div>
        <div className={Styles.footer}>
          <p>
            <b>{t("dashboard.completeCS")}</b>
          </p>
          <div className={Styles.footerLinks}>
            <Link to={csFormPageGasUrl} className={link}>
              <span>{t("dashboard.gas")}</span> <Icon className={Styles.arrow} name={"arrowRight"} />
            </Link>
            <Link to={csFormPageStormUrl} className={link}>
              <span>{t("dashboard.electricity")}</span> <Icon className={Styles.arrow} name={"arrowRight"} />
            </Link>
            <Link to={csFormPageHeatpumpUrl} className={link}>
              <span>{t("dashboard.heatPump")}</span> <Icon className={Styles.arrow} name={"arrowRight"} />
            </Link>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className={Styles.completeCSWrapper}>
      <h4 className={classNames(Styles.completeCS, "oswald")}>{t("dashboard.completeCS")}</h4>
      <div className={Styles.completeCSButtons}>
        <BoxButton link={csFormPageStormUrl} text="Strom" />
        <BoxButton link={csFormPageGasUrl} text="Gas" />
      </div>
    </div>
  );

  return (
    <div className={classNames(Styles.dashboardBoxWrapper, className)}>
      <div className={Styles.upperBox}>
        <h2 className={classNames(Styles.title, "oswald")}>{t("dashboard.changeServices.title")}</h2>
        <p className={Styles.subTitle}>{subTitle}</p>
        <div>
          <div className={Styles.itemWrapper}>
            <p key="itemsChangeServices_1" className={Styles.csItem}>
              {activeChangeServicesCount}
            </p>
            <b>{t("dashboard.activeCSs")}</b>
          </div>
          <div className={Styles.itemWrapper}>
            {!!missingDataChangeServices.length && (
              <>
                <p
                  key="itemsChangeServices_2"
                  className={classNames(Styles.remindersItemWithMissingData, warningBackground)}
                >
                  {missingDataChangeServices.length}
                </p>
                <b>{t("dashboard.CSsWithMissingData")}</b>
              </>
            )}
          </div>
        </div>
        {boxContent}
      </div>
    </div>
  );
};
